<template>
  <div class="event-child">
    <h2 class="event-subtitle">Регистрация</h2>

    <h3 v-if="loggedIn && registered" style="text-align: center;">Вече сте регистрирани за гласуване.</h3>

    <div v-else-if="!registrationSubmitted">
      <form @submit.prevent="submitForm">
        <p>
          <label for="first_name">Име<sup class="required-field">*</sup></label>
          <input type="text" v-validate="'required'" v-model="user.first_name"
            name="first_name" id="first_name">
          <small v-show="errors.has('first_name')" class="help">{{ errors.first('first_name') }}</small>
        </p>
        <p>
          <label for="middle_name">Презиме<sup class="required-field">*</sup></label>
          <input type="text" v-validate="'required'" v-model="user.middle_name"
            name="middle_name" id="middle_name" @focus="validateUpTo('middle_name')">
          <small v-show="errors.has('middle_name')" class="help">{{ errors.first('middle_name') }}</small>
        </p>
        <p>
          <label for="last_name">Фамилия<sup class="required-field">*</sup></label>
          <input type="text" v-validate="'required'" v-model="user.last_name"
            name="last_name" id="last_name" @focus="validateUpTo('last_name')">
          <small v-show="errors.has('last_name')" class="help">{{ errors.first('last_name') }}</small>
        </p>
        <p>
          <label for="email">Електронна поща<sup class="required-field">*</sup></label>
          <input type="text" v-validate="'required|email'" v-model="user.email"
            :disabled="loggedIn" name="email" id="email" @focus="validateUpTo('email')">
          <small v-show="errors.has('email')" class="help">{{ errors.first('email') }}</small>
        </p>
        <p>
          <label for="tel">Телефон за връзка<sup class="required-field">*</sup></label>
          <input type="text" v-validate="'required'" v-model="user.tel" name="tel" id="tel" @focus="validateUpTo('tel')">
          <small v-show="errors.has('tel')" class="help">{{ errors.first('tel') }}</small>
        </p>
        <p>
          <label for="political_party">Членство в политическа партия</label>
          <input type="text" v-model="user.politicalParty" id="political_party">
        </p>
        <p>
          <label for="egn">Последните 4 цифри от ЕГН<sup class="required-field">*</sup></label>
          <input type="text" v-validate="'required|digits:4'" maxlength="4"
            v-model="user.egn" name="egn" id="egn" @focus="validateUpTo('egn')">
          <small v-show="errors.has('egn')" class="help">{{ errors.first('egn') }}</small>
        </p>
        <p>
          <label for="province">Област<sup class="required-field">*</sup></label>
          <select id="province" name="province" v-model="province" v-validate="'required'" @focus="validateUpTo('province')">
            <option></option>
            <option
              v-for="(province, i) in provinces"
              :value="province.name"
              v-html="province.name"
              :key="`province${i}`"
            ></option>
          </select>
          <small v-show="errors.has('province')" class="help">{{ errors.first('province') }}</small>
        </p>
        <p>
          <label for="place">Населено място<sup class="required-field">*</sup></label>
          <select id="place" name="place" v-model="user.place" v-validate="'required'" @focus="validateUpTo('place')">
            <option></option>
            <option
              v-for="(place, i) in places"
              :value="place.id"
              v-html="place.name"
              :key="`place${i}`"
            ></option>
          </select>
          <small v-show="errors.has('place')" class="help">{{ errors.first('place') }}</small>
        </p>
        <p>
          <label for="code">Регистрационен код<sup class="required-field">*</sup></label>
          <input type="text" v-validate="'required|length:8'" v-model="user.code" id="code" name="code"
            @focus="validateUpTo('code')">
          <small v-show="errors.has('code')" class="help">{{ errors.first('code') }}</small>
        </p>

        <div class="checkbox-field">
          <p>
            <label><small><input type="checkbox" v-model="user.newsletter" id="newsletter" name="newsletter" class="styled">ДА България ще използва личните Ви данни само за целите на Вътрешните избори за определяне на кандидатите на партията за изборите за Европейски парламент през 2019 г. Ако сте съгласен/а да получавате седмичния ни бюлетин и други съобщения от партията, моля натиснете тук.</small></label>
          </p>
        </div>

        <div class="checkbox-field">
          <p>
            <label>
              <small>
                <input type="checkbox" v-model="user.toc" id="toc" name="toc" class="styled" v-validate="'required'">Споделям <a href="https://demokrati.bg/manifest/" @click.prevent="openExternal($event)">ценностите и принципите</a> на ДА България и Демократична България, залегнали в техните <a href="https://dabulgaria.bg/za-nas/dokumenti/uchreditelna-deklaratsiya/" @click.prevent="openExternal($event)">учредителни декларации</a>
                <sup class="required-field">*</sup>
                <span v-show="errors.has('toc')" class="help"><br>{{ errors.first('toc') }}</span>
              </small>
            </label>
          </p>
        </div>

        <p>
          <input type="submit" value="Изпрати" class="arrow-send" :disabled="submitDisabled">
        </p>
      </form>
    </div>

    <Alert v-if="showError" @close="dismissError">
      <h3 slot="header">Грешка</h3>
      <div slot="body">
        <p>{{ error }}</p>
        <p>За въпроси относно процеса на регистрация се свържете с <a href="mailto:izbori@dabulgaria.bg">izbori@dabulgaria.bg</a></p>
      </div>
    </Alert>

    <h3 v-if="registrationSubmitted" style="text-align: center;">
      Вашата регистрация беше приета. Данните Ви ще бъдат верифицирани и само ако има проблем ще се свържем с Вас. Ще получите допълнително съобщение за началото на електронното гласуване. Благодарим Ви!
    </h3>

  </div>
</template>

<script>
import Alert from '@/components/Utils/Dialog.vue'

export default {
  name: 'ElectionRegistration',

  components: { Alert },

  data () {
    return {
      error: '',
      showError: false,
      registered: false,
      registrationSubmitted: false,
      user: {
        first_name: '',
        middle_name: '',
        last_name: '',
        egn: '',
        tel: '',
        email: '',
        place: '',
        politicalParty: '',
        newsletter: 0,
        code: '',
        toc: 0
      },
      province: ''
    }
  },

  mounted () {
    if (this.loggedIn) {
      this.$store.dispatch('checkOwnRegistration').then(() => {
        this.registered = true
      }).catch(() => {
        this.registered = false
      })

      this.user.first_name = this.$store.getters.user.first_name
      this.user.last_name = this.$store.getters.user.last_name
      this.user.email = this.$store.getters.user.email
    }

    this.user.code = this.$route.params.code || ''

    this.$store.dispatch('getProvinces')
  },

  computed: {
    submitDisabled () {
      return this.user.first_name.length === 0 || this.user.last_name.length === 0 ||
        this.user.middle_name.length === 0 || this.user.email.length === 0 ||
        this.user.place.length === 0 || this.user.tel.length === 0 ||
        this.user.egn.length === 0 || this.province.length === 0 ||
        this.user.code.length !== 8 || this.user.toc === 0 ||
        this.errors.items.length > 0 || this.loading
    },

    loading () {
      return this.$store.getters.loading
    },

    election () {
      return this.$store.getters.election
    },

    loggedIn () {
      return this.$store.getters.loggedIn
    },

    provinces () {
      return this.$store.getters.provinces
    },

    places () {
      return this.$store.getters.places
    }
  },

  methods: {
    dismissError () {
      this.error = false
      this.showError = false
    },
    openExternal (e) {
      window.open(e.target.href, '_system')
      return false
    },

    submitForm () {
      this.$store.commit('setLoading', true)
      this.$store.dispatch('submitElectionRegistration', this.user).then(() => {
        this.$store.commit('setLoading', false)
        this.registrationSubmitted = true
      }).catch(err => {
        this.error = err.response.data.error
        this.showError = true
        this.$store.commit('setLoading', false)
      })
    },

    validateUpTo (fieldName) {
      for (let field of this.$validator.fields.items) {
        if (field.name === fieldName) {
          break
        }

        this.$validator.validate(field.name)
      }
    }
  },

  watch: {
    // trim white space around email
    'user.email': function (newValue) {
      this.user.email = newValue.replace(/ /g, '')
    },
    province (val) {
      if (val.length > 0) {
        this.$store.commit('setPlaces', [])
        this.$store.dispatch('getPlacesInProvince', this.province)
      }
    }
  }
}
</script>
